module.exports = __webpack_public_path__ + "img/19-about.c6189e83.jpg";